/**
 * Computes a document quality score (0-100)
 * @param {Object} doc - DmsDocument object
 * @returns {{ score: number, breakdown: Object, suggestions: string[] }}
 */
export function computeQualityScore(doc) {
  if (!doc) return { score: 0, breakdown: {}, suggestions: [] };

  const breakdown = {};
  const suggestions = [];

  // 1. Completeness (30 pts)
  let completeness = 0;
  if (doc.title && doc.title.length > 5) completeness += 8;
  if (doc.description && doc.description.length > 20) completeness += 8;
  else suggestions.push('Add a detailed description');
  if (doc.tags && doc.tags.length >= 2) completeness += 8;
  else suggestions.push('Add at least 2 tags for discoverability');
  if (doc.vault) completeness += 6;
  breakdown.completeness = completeness;

  // 2. Classification (20 pts)
  const classScores = { secret: 20, restricted: 18, confidential: 16, internal: 14, unclassified: 4 };
  const classScore = classScores[doc.classification] || 0;
  if (doc.classification === 'unclassified') suggestions.push('Set a security classification');
  breakdown.classification = classScore;

  // 3. Content Quality (25 pts)
  let contentScore = 0;
  if (doc.aiSummary && doc.aiSummary.length > 50) contentScore += 12;
  else suggestions.push('Generate an AI summary for better discoverability');
  if (doc.extractedText && doc.extractedText.length > 200) contentScore += 13;
  breakdown.content = contentScore;

  // 4. Governance (25 pts)
  let govScore = 0;
  if (doc.status === 'published') govScore += 12;
  else if (doc.status === 'review') govScore += 8;
  else if (doc.status === 'draft') { govScore += 3; suggestions.push('Submit for review or publish the document'); }
  if (doc.expiresAt) govScore += 8;
  else if (doc.vault === 'legal' || doc.vault === 'contracts') suggestions.push('Set an expiry date for this legal/contract document');
  if (doc.createdBy) govScore += 5;
  breakdown.governance = govScore;

  const score = Math.min(100, completeness + classScore + contentScore + govScore);

  return { score, breakdown, suggestions: suggestions.slice(0, 3) };
}

export function getScoreColor(score) {
  if (score >= 80) return '#4caf50';
  if (score >= 60) return '#ff9800';
  if (score >= 40) return '#ff5722';
  return '#f44336';
}
